module.exports = __webpack_public_path__ + "media/images/user/note-6fec8a25444ac26370ad92b4297f112c.svg";